import {Spin} from '@yandex-lego/components/Spin/desktop/bundle';
import block from 'bem-cn-lite';
import React, {ReactElement, useEffect, useRef, useState} from 'react';
import fetchData from 'utils/fetchData';

const b = block('DataLoader');

type Props<DataType extends {}> = {
  urls: {[id in keyof DataType]: string};
  typecast?: (rawData: DataType) => DataType;
  csvDelimiter?: string;
  children: (data: DataType) => ReactElement;
};

const DataLoader: <DataType extends {}>(props: Props<DataType>) => ReactElement = <
  DataType extends {}
>({
  urls,
  children,
  csvDelimiter = ',',
  typecast = data => data,
}: Props<DataType>) => {
  const loadedData = useRef<DataType>({} as DataType);
  const [loadingCount, setLoadingCount] = useState<number>(Object.keys(urls).length);

  useEffect(
    function startDownloads() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Object.entries(urls).forEach(([dataId, dataUrl]: [string, any]) => {
        fetchData(
          dataUrl,
          (data: unknown) => {
            (loadedData.current as {[dataId: string]: unknown})[dataId] = data;
            setLoadingCount(count => count - 1);
          },
          () => {
            throw new Error(`Ошибка при загрузке данных по адресу ${dataUrl}`);
          },
          csvDelimiter,
        );
      });
    },
    [urls, csvDelimiter],
  );

  if (loadingCount > 0) {
    return (
      <div className={b({loading: true})}>
        <Spin progress position="center" view="default" size="l" />
      </div>
    );
  } else {
    return children(typecast(loadedData.current));
  }
};

export default DataLoader;
